<template>
  <div>
    <modal-provider
      name="result-modal"
      title=""
      :width="600"
      @before-open="beforeOpen"
      classList=""
    >
      <div ref="modal" class="modal result" tabindex="0">
        <img v-if="type" class="result__img" :src="`/img/modal/${this.type}.svg`" alt="">
        <div v-if="computedTitle" class="result__title">{{ computedTitle }}</div>
        <div v-if="computedSubtitle" class="result__subtitle">{{ computedSubtitle }}</div>
        <Button
          v-if="computedBtnText"
          class="result__btn"
          @click.native="hideModal"
        >
          {{ computedBtnText }}
        </Button>
      </div>
    </modal-provider>
  </div>
</template>

<script>
import Button from '@/components/inputs/Button.vue'

export default {
  name: 'ResultModal',
  components: { Button },
  data: function () {
    return {
      type: 'success',
      title: '',
      subtitle: '',
      btnText: ''
    }
  },
  methods: {
    hideModal () {
      this.$modal.hide('result-modal')
    },
    beforeOpen ({ params }) {
      this.type = params?.type || 'success'
      this.title = params?.title || ''
      this.subtitle = params?.subtitle || ''
      this.btnText = params?.btnText || ''
    }
  },
  computed: {
    computedTitle () {
      return this.$t(this.title)
    },
    computedSubtitle () {
      return this.$t(this.subtitle)
    },
    computedBtnText () {
      return this.$t(this.btnText)
    }
  }
}
</script>

<style lang="sass" scoped>
::v-deep .modal__title
  margin-bottom: 0
.result
  display: flex
  flex-direction: column
  align-items: center
  &__btn
    font-size: 14px
  &__subtitle
    font-size: 16px
    color: #333
    line-height: 1.5
    text-align: center
    margin-bottom: 30px
    +mmax($tablet--hor)
      font-size: 14px
      margin-bottom: 25px
  &__title
    color: #333
    font-size: 24px
    font-weight: 500
    margin-bottom: 15px
    text-align: center
    +mmax($tablet--hor)
      font-size: 18px
      margin-bottom: 10px
  &__img
    width: 76px
    height: auto
    margin: 0 auto 20px
</style>
